import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import DescriptionIcon from '@mui/icons-material/Description';
import { ViewMode, PUBLISH_ASSET_MODES } from './usePublishAssetData';

const ViewModeToggle = ({ value, onChange }: { value: ViewMode; onChange: (v: ViewMode) => void }) => (
  <ToggleButtonGroup value={value} exclusive onChange={(_, v) => v && onChange(v)}>
    <ToggleButton value={PUBLISH_ASSET_MODES.SOURCE}>
      <CodeIcon sx={{ mr: 1 }} />
      Source
    </ToggleButton>
    <ToggleButton value={PUBLISH_ASSET_MODES.RENDERED}>
      <DescriptionIcon sx={{ mr: 1 }} />
      Rendered
    </ToggleButton>
  </ToggleButtonGroup>
);

export default ViewModeToggle;
